/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as VendorRegistrationRouteImport } from './routes/vendor-registration'
import { Route as VendorRouteImport } from './routes/vendor'
import { Route as TestPaymentRouteImport } from './routes/test-payment'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as QueryRouteImport } from './routes/query'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PolicyRouteImport } from './routes/policy'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as LegalRouteImport } from './routes/legal'
import { Route as GetStartedRouteImport } from './routes/get-started'
import { Route as FormRouteImport } from './routes/form'
import { Route as FeaturesRouteImport } from './routes/features'
import { Route as DownloadRouteImport } from './routes/download'
import { Route as DiscoveryRouteImport } from './routes/discovery'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as BuyerRouteImport } from './routes/buyer'
import { Route as BagRouteImport } from './routes/bag'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VendorSupportRouteImport } from './routes/vendor/support'
import { Route as VendorNotificationsRouteImport } from './routes/vendor/notifications'
import { Route as VendorHomeRouteImport } from './routes/vendor/home'
import { Route as VendorDisputeRouteImport } from './routes/vendor/dispute'
import { Route as ProductProductidRouteImport } from './routes/product/$productid'
import { Route as PaymentContractidRouteImport } from './routes/payment/$contractid'
import { Route as CheckoutSummaryRouteImport } from './routes/checkout/summary'
import { Route as CheckoutShippingRouteImport } from './routes/checkout/shipping'
import { Route as BuyerSupportRouteImport } from './routes/buyer/support'
import { Route as BuyerNotificationsRouteImport } from './routes/buyer/notifications'
import { Route as BuyerHomeRouteImport } from './routes/buyer/home'
import { Route as BuyerDisputeRouteImport } from './routes/buyer/dispute'
import { Route as AuthVerifyEmailRouteImport } from './routes/_auth/verify-email'
import { Route as AuthUserTypeRouteImport } from './routes/_auth/user-type'
import { Route as AuthSignUpRouteImport } from './routes/_auth/sign-up'
import { Route as AuthSignInRouteImport } from './routes/_auth/sign-in'
import { Route as VendorStoreIndexRouteImport } from './routes/vendor/store/index'
import { Route as VendorSettingsIndexRouteImport } from './routes/vendor/settings/index'
import { Route as VendorOrdersIndexRouteImport } from './routes/vendor/orders/index'
import { Route as VendorContractIndexRouteImport } from './routes/vendor/contract/index'
import { Route as VendorChatIndexRouteImport } from './routes/vendor/chat/index'
import { Route as BuyerVendorIndexRouteImport } from './routes/buyer/vendor/index'
import { Route as BuyerSettingsIndexRouteImport } from './routes/buyer/settings/index'
import { Route as BuyerOrdersIndexRouteImport } from './routes/buyer/orders/index'
import { Route as BuyerChatIndexRouteImport } from './routes/buyer/chat/index'
import { Route as VendorStoreCreateRouteImport } from './routes/vendor/store/create'
import { Route as VendorStoreProductidRouteImport } from './routes/vendor/store/$productid'
import { Route as VendorOrdersOrderidRouteImport } from './routes/vendor/orders/$orderid'
import { Route as VendorDisputeDisputeidRouteImport } from './routes/vendor/dispute/$disputeid'
import { Route as VendorContractDropoffLocationRouteImport } from './routes/vendor/contract/dropoff-location'
import { Route as VendorContractCreateRouteImport } from './routes/vendor/contract/create'
import { Route as VendorContractCartRouteImport } from './routes/vendor/contract/cart'
import { Route as VendorChatRoomidRouteImport } from './routes/vendor/chat/$roomid'
import { Route as BuyerVendorVendoridRouteImport } from './routes/buyer/vendor/$vendorid'
import { Route as BuyerSettingsMyAccountRouteImport } from './routes/buyer/settings/my-account'
import { Route as BuyerDisputeDisputeidRouteImport } from './routes/buyer/dispute/$disputeid'
import { Route as BuyerChatRoomidRouteImport } from './routes/buyer/chat/$roomid'
import { Route as VendorContractContractidIndexRouteImport } from './routes/vendor/contract/$contractid/index'
import { Route as BuyerOrdersOrderidIndexRouteImport } from './routes/buyer/orders/$orderid/index'
import { Route as VendorStoreEditProductidRouteImport } from './routes/vendor/store/edit.$productid'
import { Route as VendorContractContractidEditRouteImport } from './routes/vendor/contract/$contractid/edit'
import { Route as BuyerOrdersOrderidChatRouteImport } from './routes/buyer/orders/$orderid/chat'

const AuthForgotPasswordLazyRouteImport = createFileRoute(
  '/_auth/forgot-password',
)()

const VendorRegistrationRoute = VendorRegistrationRouteImport.update({
  id: '/vendor-registration',
  path: '/vendor-registration',
  getParentRoute: () => rootRouteImport,
} as any)
const VendorRoute = VendorRouteImport.update({
  id: '/vendor',
  path: '/vendor',
  getParentRoute: () => rootRouteImport,
} as any)
const TestPaymentRoute = TestPaymentRouteImport.update({
  id: '/test-payment',
  path: '/test-payment',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const QueryRoute = QueryRouteImport.update({
  id: '/query',
  path: '/query',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PolicyRoute = PolicyRouteImport.update({
  id: '/policy',
  path: '/policy',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalRoute = LegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => rootRouteImport,
} as any)
const GetStartedRoute = GetStartedRouteImport.update({
  id: '/get-started',
  path: '/get-started',
  getParentRoute: () => rootRouteImport,
} as any)
const FormRoute = FormRouteImport.update({
  id: '/form',
  path: '/form',
  getParentRoute: () => rootRouteImport,
} as any)
const FeaturesRoute = FeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => rootRouteImport,
} as any)
const DownloadRoute = DownloadRouteImport.update({
  id: '/download',
  path: '/download',
  getParentRoute: () => rootRouteImport,
} as any)
const DiscoveryRoute = DiscoveryRouteImport.update({
  id: '/discovery',
  path: '/discovery',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const BuyerRoute = BuyerRouteImport.update({
  id: '/buyer',
  path: '/buyer',
  getParentRoute: () => rootRouteImport,
} as any)
const BagRoute = BagRouteImport.update({
  id: '/bag',
  path: '/bag',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthForgotPasswordLazyRoute = AuthForgotPasswordLazyRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/_auth/forgot-password.lazy').then((d) => d.Route),
)
const VendorSupportRoute = VendorSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => VendorRoute,
} as any)
const VendorNotificationsRoute = VendorNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => VendorRoute,
} as any)
const VendorHomeRoute = VendorHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => VendorRoute,
} as any)
const VendorDisputeRoute = VendorDisputeRouteImport.update({
  id: '/dispute',
  path: '/dispute',
  getParentRoute: () => VendorRoute,
} as any)
const ProductProductidRoute = ProductProductidRouteImport.update({
  id: '/product/$productid',
  path: '/product/$productid',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentContractidRoute = PaymentContractidRouteImport.update({
  id: '/payment/$contractid',
  path: '/payment/$contractid',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutSummaryRoute = CheckoutSummaryRouteImport.update({
  id: '/checkout/summary',
  path: '/checkout/summary',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutShippingRoute = CheckoutShippingRouteImport.update({
  id: '/checkout/shipping',
  path: '/checkout/shipping',
  getParentRoute: () => rootRouteImport,
} as any)
const BuyerSupportRoute = BuyerSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => BuyerRoute,
} as any)
const BuyerNotificationsRoute = BuyerNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => BuyerRoute,
} as any)
const BuyerHomeRoute = BuyerHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => BuyerRoute,
} as any)
const BuyerDisputeRoute = BuyerDisputeRouteImport.update({
  id: '/dispute',
  path: '/dispute',
  getParentRoute: () => BuyerRoute,
} as any)
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUserTypeRoute = AuthUserTypeRouteImport.update({
  id: '/user-type',
  path: '/user-type',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRoute,
} as any)
const VendorStoreIndexRoute = VendorStoreIndexRouteImport.update({
  id: '/store/',
  path: '/store/',
  getParentRoute: () => VendorRoute,
} as any)
const VendorSettingsIndexRoute = VendorSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => VendorRoute,
} as any)
const VendorOrdersIndexRoute = VendorOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => VendorRoute,
} as any)
const VendorContractIndexRoute = VendorContractIndexRouteImport.update({
  id: '/contract/',
  path: '/contract/',
  getParentRoute: () => VendorRoute,
} as any)
const VendorChatIndexRoute = VendorChatIndexRouteImport.update({
  id: '/chat/',
  path: '/chat/',
  getParentRoute: () => VendorRoute,
} as any)
const BuyerVendorIndexRoute = BuyerVendorIndexRouteImport.update({
  id: '/vendor/',
  path: '/vendor/',
  getParentRoute: () => BuyerRoute,
} as any)
const BuyerSettingsIndexRoute = BuyerSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => BuyerRoute,
} as any)
const BuyerOrdersIndexRoute = BuyerOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => BuyerRoute,
} as any)
const BuyerChatIndexRoute = BuyerChatIndexRouteImport.update({
  id: '/chat/',
  path: '/chat/',
  getParentRoute: () => BuyerRoute,
} as any)
const VendorStoreCreateRoute = VendorStoreCreateRouteImport.update({
  id: '/store/create',
  path: '/store/create',
  getParentRoute: () => VendorRoute,
} as any)
const VendorStoreProductidRoute = VendorStoreProductidRouteImport.update({
  id: '/store/$productid',
  path: '/store/$productid',
  getParentRoute: () => VendorRoute,
} as any)
const VendorOrdersOrderidRoute = VendorOrdersOrderidRouteImport.update({
  id: '/orders/$orderid',
  path: '/orders/$orderid',
  getParentRoute: () => VendorRoute,
} as any)
const VendorDisputeDisputeidRoute = VendorDisputeDisputeidRouteImport.update({
  id: '/$disputeid',
  path: '/$disputeid',
  getParentRoute: () => VendorDisputeRoute,
} as any)
const VendorContractDropoffLocationRoute =
  VendorContractDropoffLocationRouteImport.update({
    id: '/contract/dropoff-location',
    path: '/contract/dropoff-location',
    getParentRoute: () => VendorRoute,
  } as any)
const VendorContractCreateRoute = VendorContractCreateRouteImport.update({
  id: '/contract/create',
  path: '/contract/create',
  getParentRoute: () => VendorRoute,
} as any)
const VendorContractCartRoute = VendorContractCartRouteImport.update({
  id: '/contract/cart',
  path: '/contract/cart',
  getParentRoute: () => VendorRoute,
} as any)
const VendorChatRoomidRoute = VendorChatRoomidRouteImport.update({
  id: '/chat/$roomid',
  path: '/chat/$roomid',
  getParentRoute: () => VendorRoute,
} as any)
const BuyerVendorVendoridRoute = BuyerVendorVendoridRouteImport.update({
  id: '/vendor/$vendorid',
  path: '/vendor/$vendorid',
  getParentRoute: () => BuyerRoute,
} as any)
const BuyerSettingsMyAccountRoute = BuyerSettingsMyAccountRouteImport.update({
  id: '/settings/my-account',
  path: '/settings/my-account',
  getParentRoute: () => BuyerRoute,
} as any)
const BuyerDisputeDisputeidRoute = BuyerDisputeDisputeidRouteImport.update({
  id: '/$disputeid',
  path: '/$disputeid',
  getParentRoute: () => BuyerDisputeRoute,
} as any)
const BuyerChatRoomidRoute = BuyerChatRoomidRouteImport.update({
  id: '/chat/$roomid',
  path: '/chat/$roomid',
  getParentRoute: () => BuyerRoute,
} as any)
const VendorContractContractidIndexRoute =
  VendorContractContractidIndexRouteImport.update({
    id: '/contract/$contractid/',
    path: '/contract/$contractid/',
    getParentRoute: () => VendorRoute,
  } as any)
const BuyerOrdersOrderidIndexRoute = BuyerOrdersOrderidIndexRouteImport.update({
  id: '/orders/$orderid/',
  path: '/orders/$orderid/',
  getParentRoute: () => BuyerRoute,
} as any)
const VendorStoreEditProductidRoute =
  VendorStoreEditProductidRouteImport.update({
    id: '/store/edit/$productid',
    path: '/store/edit/$productid',
    getParentRoute: () => VendorRoute,
  } as any)
const VendorContractContractidEditRoute =
  VendorContractContractidEditRouteImport.update({
    id: '/contract/$contractid/edit',
    path: '/contract/$contractid/edit',
    getParentRoute: () => VendorRoute,
  } as any)
const BuyerOrdersOrderidChatRoute = BuyerOrdersOrderidChatRouteImport.update({
  id: '/orders/$orderid/chat',
  path: '/orders/$orderid/chat',
  getParentRoute: () => BuyerRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/bag': typeof BagRoute
  '/buyer': typeof BuyerRouteWithChildren
  '/contact': typeof ContactRoute
  '/discovery': typeof DiscoveryRoute
  '/download': typeof DownloadRoute
  '/features': typeof FeaturesRoute
  '/form': typeof FormRoute
  '/get-started': typeof GetStartedRoute
  '/legal': typeof LegalRoute
  '/onboarding': typeof OnboardingRoute
  '/policy': typeof PolicyRoute
  '/privacy': typeof PrivacyRoute
  '/query': typeof QueryRoute
  '/terms': typeof TermsRoute
  '/test-payment': typeof TestPaymentRoute
  '/vendor': typeof VendorRouteWithChildren
  '/vendor-registration': typeof VendorRegistrationRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-up': typeof AuthSignUpRoute
  '/user-type': typeof AuthUserTypeRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/buyer/dispute': typeof BuyerDisputeRouteWithChildren
  '/buyer/home': typeof BuyerHomeRoute
  '/buyer/notifications': typeof BuyerNotificationsRoute
  '/buyer/support': typeof BuyerSupportRoute
  '/checkout/shipping': typeof CheckoutShippingRoute
  '/checkout/summary': typeof CheckoutSummaryRoute
  '/payment/$contractid': typeof PaymentContractidRoute
  '/product/$productid': typeof ProductProductidRoute
  '/vendor/dispute': typeof VendorDisputeRouteWithChildren
  '/vendor/home': typeof VendorHomeRoute
  '/vendor/notifications': typeof VendorNotificationsRoute
  '/vendor/support': typeof VendorSupportRoute
  '/forgot-password': typeof AuthForgotPasswordLazyRoute
  '/buyer/chat/$roomid': typeof BuyerChatRoomidRoute
  '/buyer/dispute/$disputeid': typeof BuyerDisputeDisputeidRoute
  '/buyer/settings/my-account': typeof BuyerSettingsMyAccountRoute
  '/buyer/vendor/$vendorid': typeof BuyerVendorVendoridRoute
  '/vendor/chat/$roomid': typeof VendorChatRoomidRoute
  '/vendor/contract/cart': typeof VendorContractCartRoute
  '/vendor/contract/create': typeof VendorContractCreateRoute
  '/vendor/contract/dropoff-location': typeof VendorContractDropoffLocationRoute
  '/vendor/dispute/$disputeid': typeof VendorDisputeDisputeidRoute
  '/vendor/orders/$orderid': typeof VendorOrdersOrderidRoute
  '/vendor/store/$productid': typeof VendorStoreProductidRoute
  '/vendor/store/create': typeof VendorStoreCreateRoute
  '/buyer/chat/': typeof BuyerChatIndexRoute
  '/buyer/orders/': typeof BuyerOrdersIndexRoute
  '/buyer/settings/': typeof BuyerSettingsIndexRoute
  '/buyer/vendor/': typeof BuyerVendorIndexRoute
  '/vendor/chat/': typeof VendorChatIndexRoute
  '/vendor/contract/': typeof VendorContractIndexRoute
  '/vendor/orders/': typeof VendorOrdersIndexRoute
  '/vendor/settings/': typeof VendorSettingsIndexRoute
  '/vendor/store/': typeof VendorStoreIndexRoute
  '/buyer/orders/$orderid/chat': typeof BuyerOrdersOrderidChatRoute
  '/vendor/contract/$contractid/edit': typeof VendorContractContractidEditRoute
  '/vendor/store/edit/$productid': typeof VendorStoreEditProductidRoute
  '/buyer/orders/$orderid/': typeof BuyerOrdersOrderidIndexRoute
  '/vendor/contract/$contractid/': typeof VendorContractContractidIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/bag': typeof BagRoute
  '/buyer': typeof BuyerRouteWithChildren
  '/contact': typeof ContactRoute
  '/discovery': typeof DiscoveryRoute
  '/download': typeof DownloadRoute
  '/features': typeof FeaturesRoute
  '/form': typeof FormRoute
  '/get-started': typeof GetStartedRoute
  '/legal': typeof LegalRoute
  '/onboarding': typeof OnboardingRoute
  '/policy': typeof PolicyRoute
  '/privacy': typeof PrivacyRoute
  '/query': typeof QueryRoute
  '/terms': typeof TermsRoute
  '/test-payment': typeof TestPaymentRoute
  '/vendor': typeof VendorRouteWithChildren
  '/vendor-registration': typeof VendorRegistrationRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-up': typeof AuthSignUpRoute
  '/user-type': typeof AuthUserTypeRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/buyer/dispute': typeof BuyerDisputeRouteWithChildren
  '/buyer/home': typeof BuyerHomeRoute
  '/buyer/notifications': typeof BuyerNotificationsRoute
  '/buyer/support': typeof BuyerSupportRoute
  '/checkout/shipping': typeof CheckoutShippingRoute
  '/checkout/summary': typeof CheckoutSummaryRoute
  '/payment/$contractid': typeof PaymentContractidRoute
  '/product/$productid': typeof ProductProductidRoute
  '/vendor/dispute': typeof VendorDisputeRouteWithChildren
  '/vendor/home': typeof VendorHomeRoute
  '/vendor/notifications': typeof VendorNotificationsRoute
  '/vendor/support': typeof VendorSupportRoute
  '/forgot-password': typeof AuthForgotPasswordLazyRoute
  '/buyer/chat/$roomid': typeof BuyerChatRoomidRoute
  '/buyer/dispute/$disputeid': typeof BuyerDisputeDisputeidRoute
  '/buyer/settings/my-account': typeof BuyerSettingsMyAccountRoute
  '/buyer/vendor/$vendorid': typeof BuyerVendorVendoridRoute
  '/vendor/chat/$roomid': typeof VendorChatRoomidRoute
  '/vendor/contract/cart': typeof VendorContractCartRoute
  '/vendor/contract/create': typeof VendorContractCreateRoute
  '/vendor/contract/dropoff-location': typeof VendorContractDropoffLocationRoute
  '/vendor/dispute/$disputeid': typeof VendorDisputeDisputeidRoute
  '/vendor/orders/$orderid': typeof VendorOrdersOrderidRoute
  '/vendor/store/$productid': typeof VendorStoreProductidRoute
  '/vendor/store/create': typeof VendorStoreCreateRoute
  '/buyer/chat': typeof BuyerChatIndexRoute
  '/buyer/orders': typeof BuyerOrdersIndexRoute
  '/buyer/settings': typeof BuyerSettingsIndexRoute
  '/buyer/vendor': typeof BuyerVendorIndexRoute
  '/vendor/chat': typeof VendorChatIndexRoute
  '/vendor/contract': typeof VendorContractIndexRoute
  '/vendor/orders': typeof VendorOrdersIndexRoute
  '/vendor/settings': typeof VendorSettingsIndexRoute
  '/vendor/store': typeof VendorStoreIndexRoute
  '/buyer/orders/$orderid/chat': typeof BuyerOrdersOrderidChatRoute
  '/vendor/contract/$contractid/edit': typeof VendorContractContractidEditRoute
  '/vendor/store/edit/$productid': typeof VendorStoreEditProductidRoute
  '/buyer/orders/$orderid': typeof BuyerOrdersOrderidIndexRoute
  '/vendor/contract/$contractid': typeof VendorContractContractidIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/bag': typeof BagRoute
  '/buyer': typeof BuyerRouteWithChildren
  '/contact': typeof ContactRoute
  '/discovery': typeof DiscoveryRoute
  '/download': typeof DownloadRoute
  '/features': typeof FeaturesRoute
  '/form': typeof FormRoute
  '/get-started': typeof GetStartedRoute
  '/legal': typeof LegalRoute
  '/onboarding': typeof OnboardingRoute
  '/policy': typeof PolicyRoute
  '/privacy': typeof PrivacyRoute
  '/query': typeof QueryRoute
  '/terms': typeof TermsRoute
  '/test-payment': typeof TestPaymentRoute
  '/vendor': typeof VendorRouteWithChildren
  '/vendor-registration': typeof VendorRegistrationRoute
  '/_auth/sign-in': typeof AuthSignInRoute
  '/_auth/sign-up': typeof AuthSignUpRoute
  '/_auth/user-type': typeof AuthUserTypeRoute
  '/_auth/verify-email': typeof AuthVerifyEmailRoute
  '/buyer/dispute': typeof BuyerDisputeRouteWithChildren
  '/buyer/home': typeof BuyerHomeRoute
  '/buyer/notifications': typeof BuyerNotificationsRoute
  '/buyer/support': typeof BuyerSupportRoute
  '/checkout/shipping': typeof CheckoutShippingRoute
  '/checkout/summary': typeof CheckoutSummaryRoute
  '/payment/$contractid': typeof PaymentContractidRoute
  '/product/$productid': typeof ProductProductidRoute
  '/vendor/dispute': typeof VendorDisputeRouteWithChildren
  '/vendor/home': typeof VendorHomeRoute
  '/vendor/notifications': typeof VendorNotificationsRoute
  '/vendor/support': typeof VendorSupportRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordLazyRoute
  '/buyer/chat/$roomid': typeof BuyerChatRoomidRoute
  '/buyer/dispute/$disputeid': typeof BuyerDisputeDisputeidRoute
  '/buyer/settings/my-account': typeof BuyerSettingsMyAccountRoute
  '/buyer/vendor/$vendorid': typeof BuyerVendorVendoridRoute
  '/vendor/chat/$roomid': typeof VendorChatRoomidRoute
  '/vendor/contract/cart': typeof VendorContractCartRoute
  '/vendor/contract/create': typeof VendorContractCreateRoute
  '/vendor/contract/dropoff-location': typeof VendorContractDropoffLocationRoute
  '/vendor/dispute/$disputeid': typeof VendorDisputeDisputeidRoute
  '/vendor/orders/$orderid': typeof VendorOrdersOrderidRoute
  '/vendor/store/$productid': typeof VendorStoreProductidRoute
  '/vendor/store/create': typeof VendorStoreCreateRoute
  '/buyer/chat/': typeof BuyerChatIndexRoute
  '/buyer/orders/': typeof BuyerOrdersIndexRoute
  '/buyer/settings/': typeof BuyerSettingsIndexRoute
  '/buyer/vendor/': typeof BuyerVendorIndexRoute
  '/vendor/chat/': typeof VendorChatIndexRoute
  '/vendor/contract/': typeof VendorContractIndexRoute
  '/vendor/orders/': typeof VendorOrdersIndexRoute
  '/vendor/settings/': typeof VendorSettingsIndexRoute
  '/vendor/store/': typeof VendorStoreIndexRoute
  '/buyer/orders/$orderid/chat': typeof BuyerOrdersOrderidChatRoute
  '/vendor/contract/$contractid/edit': typeof VendorContractContractidEditRoute
  '/vendor/store/edit/$productid': typeof VendorStoreEditProductidRoute
  '/buyer/orders/$orderid/': typeof BuyerOrdersOrderidIndexRoute
  '/vendor/contract/$contractid/': typeof VendorContractContractidIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/bag'
    | '/buyer'
    | '/contact'
    | '/discovery'
    | '/download'
    | '/features'
    | '/form'
    | '/get-started'
    | '/legal'
    | '/onboarding'
    | '/policy'
    | '/privacy'
    | '/query'
    | '/terms'
    | '/test-payment'
    | '/vendor'
    | '/vendor-registration'
    | '/sign-in'
    | '/sign-up'
    | '/user-type'
    | '/verify-email'
    | '/buyer/dispute'
    | '/buyer/home'
    | '/buyer/notifications'
    | '/buyer/support'
    | '/checkout/shipping'
    | '/checkout/summary'
    | '/payment/$contractid'
    | '/product/$productid'
    | '/vendor/dispute'
    | '/vendor/home'
    | '/vendor/notifications'
    | '/vendor/support'
    | '/forgot-password'
    | '/buyer/chat/$roomid'
    | '/buyer/dispute/$disputeid'
    | '/buyer/settings/my-account'
    | '/buyer/vendor/$vendorid'
    | '/vendor/chat/$roomid'
    | '/vendor/contract/cart'
    | '/vendor/contract/create'
    | '/vendor/contract/dropoff-location'
    | '/vendor/dispute/$disputeid'
    | '/vendor/orders/$orderid'
    | '/vendor/store/$productid'
    | '/vendor/store/create'
    | '/buyer/chat/'
    | '/buyer/orders/'
    | '/buyer/settings/'
    | '/buyer/vendor/'
    | '/vendor/chat/'
    | '/vendor/contract/'
    | '/vendor/orders/'
    | '/vendor/settings/'
    | '/vendor/store/'
    | '/buyer/orders/$orderid/chat'
    | '/vendor/contract/$contractid/edit'
    | '/vendor/store/edit/$productid'
    | '/buyer/orders/$orderid/'
    | '/vendor/contract/$contractid/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/bag'
    | '/buyer'
    | '/contact'
    | '/discovery'
    | '/download'
    | '/features'
    | '/form'
    | '/get-started'
    | '/legal'
    | '/onboarding'
    | '/policy'
    | '/privacy'
    | '/query'
    | '/terms'
    | '/test-payment'
    | '/vendor'
    | '/vendor-registration'
    | '/sign-in'
    | '/sign-up'
    | '/user-type'
    | '/verify-email'
    | '/buyer/dispute'
    | '/buyer/home'
    | '/buyer/notifications'
    | '/buyer/support'
    | '/checkout/shipping'
    | '/checkout/summary'
    | '/payment/$contractid'
    | '/product/$productid'
    | '/vendor/dispute'
    | '/vendor/home'
    | '/vendor/notifications'
    | '/vendor/support'
    | '/forgot-password'
    | '/buyer/chat/$roomid'
    | '/buyer/dispute/$disputeid'
    | '/buyer/settings/my-account'
    | '/buyer/vendor/$vendorid'
    | '/vendor/chat/$roomid'
    | '/vendor/contract/cart'
    | '/vendor/contract/create'
    | '/vendor/contract/dropoff-location'
    | '/vendor/dispute/$disputeid'
    | '/vendor/orders/$orderid'
    | '/vendor/store/$productid'
    | '/vendor/store/create'
    | '/buyer/chat'
    | '/buyer/orders'
    | '/buyer/settings'
    | '/buyer/vendor'
    | '/vendor/chat'
    | '/vendor/contract'
    | '/vendor/orders'
    | '/vendor/settings'
    | '/vendor/store'
    | '/buyer/orders/$orderid/chat'
    | '/vendor/contract/$contractid/edit'
    | '/vendor/store/edit/$productid'
    | '/buyer/orders/$orderid'
    | '/vendor/contract/$contractid'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/bag'
    | '/buyer'
    | '/contact'
    | '/discovery'
    | '/download'
    | '/features'
    | '/form'
    | '/get-started'
    | '/legal'
    | '/onboarding'
    | '/policy'
    | '/privacy'
    | '/query'
    | '/terms'
    | '/test-payment'
    | '/vendor'
    | '/vendor-registration'
    | '/_auth/sign-in'
    | '/_auth/sign-up'
    | '/_auth/user-type'
    | '/_auth/verify-email'
    | '/buyer/dispute'
    | '/buyer/home'
    | '/buyer/notifications'
    | '/buyer/support'
    | '/checkout/shipping'
    | '/checkout/summary'
    | '/payment/$contractid'
    | '/product/$productid'
    | '/vendor/dispute'
    | '/vendor/home'
    | '/vendor/notifications'
    | '/vendor/support'
    | '/_auth/forgot-password'
    | '/buyer/chat/$roomid'
    | '/buyer/dispute/$disputeid'
    | '/buyer/settings/my-account'
    | '/buyer/vendor/$vendorid'
    | '/vendor/chat/$roomid'
    | '/vendor/contract/cart'
    | '/vendor/contract/create'
    | '/vendor/contract/dropoff-location'
    | '/vendor/dispute/$disputeid'
    | '/vendor/orders/$orderid'
    | '/vendor/store/$productid'
    | '/vendor/store/create'
    | '/buyer/chat/'
    | '/buyer/orders/'
    | '/buyer/settings/'
    | '/buyer/vendor/'
    | '/vendor/chat/'
    | '/vendor/contract/'
    | '/vendor/orders/'
    | '/vendor/settings/'
    | '/vendor/store/'
    | '/buyer/orders/$orderid/chat'
    | '/vendor/contract/$contractid/edit'
    | '/vendor/store/edit/$productid'
    | '/buyer/orders/$orderid/'
    | '/vendor/contract/$contractid/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  BagRoute: typeof BagRoute
  BuyerRoute: typeof BuyerRouteWithChildren
  ContactRoute: typeof ContactRoute
  DiscoveryRoute: typeof DiscoveryRoute
  DownloadRoute: typeof DownloadRoute
  FeaturesRoute: typeof FeaturesRoute
  FormRoute: typeof FormRoute
  GetStartedRoute: typeof GetStartedRoute
  LegalRoute: typeof LegalRoute
  OnboardingRoute: typeof OnboardingRoute
  PolicyRoute: typeof PolicyRoute
  PrivacyRoute: typeof PrivacyRoute
  QueryRoute: typeof QueryRoute
  TermsRoute: typeof TermsRoute
  TestPaymentRoute: typeof TestPaymentRoute
  VendorRoute: typeof VendorRouteWithChildren
  VendorRegistrationRoute: typeof VendorRegistrationRoute
  CheckoutShippingRoute: typeof CheckoutShippingRoute
  CheckoutSummaryRoute: typeof CheckoutSummaryRoute
  PaymentContractidRoute: typeof PaymentContractidRoute
  ProductProductidRoute: typeof ProductProductidRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/vendor-registration': {
      id: '/vendor-registration'
      path: '/vendor-registration'
      fullPath: '/vendor-registration'
      preLoaderRoute: typeof VendorRegistrationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vendor': {
      id: '/vendor'
      path: '/vendor'
      fullPath: '/vendor'
      preLoaderRoute: typeof VendorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test-payment': {
      id: '/test-payment'
      path: '/test-payment'
      fullPath: '/test-payment'
      preLoaderRoute: typeof TestPaymentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/query': {
      id: '/query'
      path: '/query'
      fullPath: '/query'
      preLoaderRoute: typeof QueryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/policy': {
      id: '/policy'
      path: '/policy'
      fullPath: '/policy'
      preLoaderRoute: typeof PolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal': {
      id: '/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof LegalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/get-started': {
      id: '/get-started'
      path: '/get-started'
      fullPath: '/get-started'
      preLoaderRoute: typeof GetStartedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/form': {
      id: '/form'
      path: '/form'
      fullPath: '/form'
      preLoaderRoute: typeof FormRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/features': {
      id: '/features'
      path: '/features'
      fullPath: '/features'
      preLoaderRoute: typeof FeaturesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/download': {
      id: '/download'
      path: '/download'
      fullPath: '/download'
      preLoaderRoute: typeof DownloadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/discovery': {
      id: '/discovery'
      path: '/discovery'
      fullPath: '/discovery'
      preLoaderRoute: typeof DiscoveryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/buyer': {
      id: '/buyer'
      path: '/buyer'
      fullPath: '/buyer'
      preLoaderRoute: typeof BuyerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bag': {
      id: '/bag'
      path: '/bag'
      fullPath: '/bag'
      preLoaderRoute: typeof BagRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/vendor/support': {
      id: '/vendor/support'
      path: '/support'
      fullPath: '/vendor/support'
      preLoaderRoute: typeof VendorSupportRouteImport
      parentRoute: typeof VendorRoute
    }
    '/vendor/notifications': {
      id: '/vendor/notifications'
      path: '/notifications'
      fullPath: '/vendor/notifications'
      preLoaderRoute: typeof VendorNotificationsRouteImport
      parentRoute: typeof VendorRoute
    }
    '/vendor/home': {
      id: '/vendor/home'
      path: '/home'
      fullPath: '/vendor/home'
      preLoaderRoute: typeof VendorHomeRouteImport
      parentRoute: typeof VendorRoute
    }
    '/vendor/dispute': {
      id: '/vendor/dispute'
      path: '/dispute'
      fullPath: '/vendor/dispute'
      preLoaderRoute: typeof VendorDisputeRouteImport
      parentRoute: typeof VendorRoute
    }
    '/product/$productid': {
      id: '/product/$productid'
      path: '/product/$productid'
      fullPath: '/product/$productid'
      preLoaderRoute: typeof ProductProductidRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment/$contractid': {
      id: '/payment/$contractid'
      path: '/payment/$contractid'
      fullPath: '/payment/$contractid'
      preLoaderRoute: typeof PaymentContractidRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout/summary': {
      id: '/checkout/summary'
      path: '/checkout/summary'
      fullPath: '/checkout/summary'
      preLoaderRoute: typeof CheckoutSummaryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout/shipping': {
      id: '/checkout/shipping'
      path: '/checkout/shipping'
      fullPath: '/checkout/shipping'
      preLoaderRoute: typeof CheckoutShippingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/buyer/support': {
      id: '/buyer/support'
      path: '/support'
      fullPath: '/buyer/support'
      preLoaderRoute: typeof BuyerSupportRouteImport
      parentRoute: typeof BuyerRoute
    }
    '/buyer/notifications': {
      id: '/buyer/notifications'
      path: '/notifications'
      fullPath: '/buyer/notifications'
      preLoaderRoute: typeof BuyerNotificationsRouteImport
      parentRoute: typeof BuyerRoute
    }
    '/buyer/home': {
      id: '/buyer/home'
      path: '/home'
      fullPath: '/buyer/home'
      preLoaderRoute: typeof BuyerHomeRouteImport
      parentRoute: typeof BuyerRoute
    }
    '/buyer/dispute': {
      id: '/buyer/dispute'
      path: '/dispute'
      fullPath: '/buyer/dispute'
      preLoaderRoute: typeof BuyerDisputeRouteImport
      parentRoute: typeof BuyerRoute
    }
    '/_auth/verify-email': {
      id: '/_auth/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof AuthVerifyEmailRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/user-type': {
      id: '/_auth/user-type'
      path: '/user-type'
      fullPath: '/user-type'
      preLoaderRoute: typeof AuthUserTypeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-up': {
      id: '/_auth/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof AuthRoute
    }
    '/vendor/store/': {
      id: '/vendor/store/'
      path: '/store'
      fullPath: '/vendor/store/'
      preLoaderRoute: typeof VendorStoreIndexRouteImport
      parentRoute: typeof VendorRoute
    }
    '/vendor/settings/': {
      id: '/vendor/settings/'
      path: '/settings'
      fullPath: '/vendor/settings/'
      preLoaderRoute: typeof VendorSettingsIndexRouteImport
      parentRoute: typeof VendorRoute
    }
    '/vendor/orders/': {
      id: '/vendor/orders/'
      path: '/orders'
      fullPath: '/vendor/orders/'
      preLoaderRoute: typeof VendorOrdersIndexRouteImport
      parentRoute: typeof VendorRoute
    }
    '/vendor/contract/': {
      id: '/vendor/contract/'
      path: '/contract'
      fullPath: '/vendor/contract/'
      preLoaderRoute: typeof VendorContractIndexRouteImport
      parentRoute: typeof VendorRoute
    }
    '/vendor/chat/': {
      id: '/vendor/chat/'
      path: '/chat'
      fullPath: '/vendor/chat/'
      preLoaderRoute: typeof VendorChatIndexRouteImport
      parentRoute: typeof VendorRoute
    }
    '/buyer/vendor/': {
      id: '/buyer/vendor/'
      path: '/vendor'
      fullPath: '/buyer/vendor/'
      preLoaderRoute: typeof BuyerVendorIndexRouteImport
      parentRoute: typeof BuyerRoute
    }
    '/buyer/settings/': {
      id: '/buyer/settings/'
      path: '/settings'
      fullPath: '/buyer/settings/'
      preLoaderRoute: typeof BuyerSettingsIndexRouteImport
      parentRoute: typeof BuyerRoute
    }
    '/buyer/orders/': {
      id: '/buyer/orders/'
      path: '/orders'
      fullPath: '/buyer/orders/'
      preLoaderRoute: typeof BuyerOrdersIndexRouteImport
      parentRoute: typeof BuyerRoute
    }
    '/buyer/chat/': {
      id: '/buyer/chat/'
      path: '/chat'
      fullPath: '/buyer/chat/'
      preLoaderRoute: typeof BuyerChatIndexRouteImport
      parentRoute: typeof BuyerRoute
    }
    '/vendor/store/create': {
      id: '/vendor/store/create'
      path: '/store/create'
      fullPath: '/vendor/store/create'
      preLoaderRoute: typeof VendorStoreCreateRouteImport
      parentRoute: typeof VendorRoute
    }
    '/vendor/store/$productid': {
      id: '/vendor/store/$productid'
      path: '/store/$productid'
      fullPath: '/vendor/store/$productid'
      preLoaderRoute: typeof VendorStoreProductidRouteImport
      parentRoute: typeof VendorRoute
    }
    '/vendor/orders/$orderid': {
      id: '/vendor/orders/$orderid'
      path: '/orders/$orderid'
      fullPath: '/vendor/orders/$orderid'
      preLoaderRoute: typeof VendorOrdersOrderidRouteImport
      parentRoute: typeof VendorRoute
    }
    '/vendor/dispute/$disputeid': {
      id: '/vendor/dispute/$disputeid'
      path: '/$disputeid'
      fullPath: '/vendor/dispute/$disputeid'
      preLoaderRoute: typeof VendorDisputeDisputeidRouteImport
      parentRoute: typeof VendorDisputeRoute
    }
    '/vendor/contract/dropoff-location': {
      id: '/vendor/contract/dropoff-location'
      path: '/contract/dropoff-location'
      fullPath: '/vendor/contract/dropoff-location'
      preLoaderRoute: typeof VendorContractDropoffLocationRouteImport
      parentRoute: typeof VendorRoute
    }
    '/vendor/contract/create': {
      id: '/vendor/contract/create'
      path: '/contract/create'
      fullPath: '/vendor/contract/create'
      preLoaderRoute: typeof VendorContractCreateRouteImport
      parentRoute: typeof VendorRoute
    }
    '/vendor/contract/cart': {
      id: '/vendor/contract/cart'
      path: '/contract/cart'
      fullPath: '/vendor/contract/cart'
      preLoaderRoute: typeof VendorContractCartRouteImport
      parentRoute: typeof VendorRoute
    }
    '/vendor/chat/$roomid': {
      id: '/vendor/chat/$roomid'
      path: '/chat/$roomid'
      fullPath: '/vendor/chat/$roomid'
      preLoaderRoute: typeof VendorChatRoomidRouteImport
      parentRoute: typeof VendorRoute
    }
    '/buyer/vendor/$vendorid': {
      id: '/buyer/vendor/$vendorid'
      path: '/vendor/$vendorid'
      fullPath: '/buyer/vendor/$vendorid'
      preLoaderRoute: typeof BuyerVendorVendoridRouteImport
      parentRoute: typeof BuyerRoute
    }
    '/buyer/settings/my-account': {
      id: '/buyer/settings/my-account'
      path: '/settings/my-account'
      fullPath: '/buyer/settings/my-account'
      preLoaderRoute: typeof BuyerSettingsMyAccountRouteImport
      parentRoute: typeof BuyerRoute
    }
    '/buyer/dispute/$disputeid': {
      id: '/buyer/dispute/$disputeid'
      path: '/$disputeid'
      fullPath: '/buyer/dispute/$disputeid'
      preLoaderRoute: typeof BuyerDisputeDisputeidRouteImport
      parentRoute: typeof BuyerDisputeRoute
    }
    '/buyer/chat/$roomid': {
      id: '/buyer/chat/$roomid'
      path: '/chat/$roomid'
      fullPath: '/buyer/chat/$roomid'
      preLoaderRoute: typeof BuyerChatRoomidRouteImport
      parentRoute: typeof BuyerRoute
    }
    '/vendor/contract/$contractid/': {
      id: '/vendor/contract/$contractid/'
      path: '/contract/$contractid'
      fullPath: '/vendor/contract/$contractid/'
      preLoaderRoute: typeof VendorContractContractidIndexRouteImport
      parentRoute: typeof VendorRoute
    }
    '/buyer/orders/$orderid/': {
      id: '/buyer/orders/$orderid/'
      path: '/orders/$orderid'
      fullPath: '/buyer/orders/$orderid/'
      preLoaderRoute: typeof BuyerOrdersOrderidIndexRouteImport
      parentRoute: typeof BuyerRoute
    }
    '/vendor/store/edit/$productid': {
      id: '/vendor/store/edit/$productid'
      path: '/store/edit/$productid'
      fullPath: '/vendor/store/edit/$productid'
      preLoaderRoute: typeof VendorStoreEditProductidRouteImport
      parentRoute: typeof VendorRoute
    }
    '/vendor/contract/$contractid/edit': {
      id: '/vendor/contract/$contractid/edit'
      path: '/contract/$contractid/edit'
      fullPath: '/vendor/contract/$contractid/edit'
      preLoaderRoute: typeof VendorContractContractidEditRouteImport
      parentRoute: typeof VendorRoute
    }
    '/buyer/orders/$orderid/chat': {
      id: '/buyer/orders/$orderid/chat'
      path: '/orders/$orderid/chat'
      fullPath: '/buyer/orders/$orderid/chat'
      preLoaderRoute: typeof BuyerOrdersOrderidChatRouteImport
      parentRoute: typeof BuyerRoute
    }
  }
}

interface AuthRouteChildren {
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
  AuthUserTypeRoute: typeof AuthUserTypeRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
  AuthForgotPasswordLazyRoute: typeof AuthForgotPasswordLazyRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthSignInRoute: AuthSignInRoute,
  AuthSignUpRoute: AuthSignUpRoute,
  AuthUserTypeRoute: AuthUserTypeRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
  AuthForgotPasswordLazyRoute: AuthForgotPasswordLazyRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface BuyerDisputeRouteChildren {
  BuyerDisputeDisputeidRoute: typeof BuyerDisputeDisputeidRoute
}

const BuyerDisputeRouteChildren: BuyerDisputeRouteChildren = {
  BuyerDisputeDisputeidRoute: BuyerDisputeDisputeidRoute,
}

const BuyerDisputeRouteWithChildren = BuyerDisputeRoute._addFileChildren(
  BuyerDisputeRouteChildren,
)

interface BuyerRouteChildren {
  BuyerDisputeRoute: typeof BuyerDisputeRouteWithChildren
  BuyerHomeRoute: typeof BuyerHomeRoute
  BuyerNotificationsRoute: typeof BuyerNotificationsRoute
  BuyerSupportRoute: typeof BuyerSupportRoute
  BuyerChatRoomidRoute: typeof BuyerChatRoomidRoute
  BuyerSettingsMyAccountRoute: typeof BuyerSettingsMyAccountRoute
  BuyerVendorVendoridRoute: typeof BuyerVendorVendoridRoute
  BuyerChatIndexRoute: typeof BuyerChatIndexRoute
  BuyerOrdersIndexRoute: typeof BuyerOrdersIndexRoute
  BuyerSettingsIndexRoute: typeof BuyerSettingsIndexRoute
  BuyerVendorIndexRoute: typeof BuyerVendorIndexRoute
  BuyerOrdersOrderidChatRoute: typeof BuyerOrdersOrderidChatRoute
  BuyerOrdersOrderidIndexRoute: typeof BuyerOrdersOrderidIndexRoute
}

const BuyerRouteChildren: BuyerRouteChildren = {
  BuyerDisputeRoute: BuyerDisputeRouteWithChildren,
  BuyerHomeRoute: BuyerHomeRoute,
  BuyerNotificationsRoute: BuyerNotificationsRoute,
  BuyerSupportRoute: BuyerSupportRoute,
  BuyerChatRoomidRoute: BuyerChatRoomidRoute,
  BuyerSettingsMyAccountRoute: BuyerSettingsMyAccountRoute,
  BuyerVendorVendoridRoute: BuyerVendorVendoridRoute,
  BuyerChatIndexRoute: BuyerChatIndexRoute,
  BuyerOrdersIndexRoute: BuyerOrdersIndexRoute,
  BuyerSettingsIndexRoute: BuyerSettingsIndexRoute,
  BuyerVendorIndexRoute: BuyerVendorIndexRoute,
  BuyerOrdersOrderidChatRoute: BuyerOrdersOrderidChatRoute,
  BuyerOrdersOrderidIndexRoute: BuyerOrdersOrderidIndexRoute,
}

const BuyerRouteWithChildren = BuyerRoute._addFileChildren(BuyerRouteChildren)

interface VendorDisputeRouteChildren {
  VendorDisputeDisputeidRoute: typeof VendorDisputeDisputeidRoute
}

const VendorDisputeRouteChildren: VendorDisputeRouteChildren = {
  VendorDisputeDisputeidRoute: VendorDisputeDisputeidRoute,
}

const VendorDisputeRouteWithChildren = VendorDisputeRoute._addFileChildren(
  VendorDisputeRouteChildren,
)

interface VendorRouteChildren {
  VendorDisputeRoute: typeof VendorDisputeRouteWithChildren
  VendorHomeRoute: typeof VendorHomeRoute
  VendorNotificationsRoute: typeof VendorNotificationsRoute
  VendorSupportRoute: typeof VendorSupportRoute
  VendorChatRoomidRoute: typeof VendorChatRoomidRoute
  VendorContractCartRoute: typeof VendorContractCartRoute
  VendorContractCreateRoute: typeof VendorContractCreateRoute
  VendorContractDropoffLocationRoute: typeof VendorContractDropoffLocationRoute
  VendorOrdersOrderidRoute: typeof VendorOrdersOrderidRoute
  VendorStoreProductidRoute: typeof VendorStoreProductidRoute
  VendorStoreCreateRoute: typeof VendorStoreCreateRoute
  VendorChatIndexRoute: typeof VendorChatIndexRoute
  VendorContractIndexRoute: typeof VendorContractIndexRoute
  VendorOrdersIndexRoute: typeof VendorOrdersIndexRoute
  VendorSettingsIndexRoute: typeof VendorSettingsIndexRoute
  VendorStoreIndexRoute: typeof VendorStoreIndexRoute
  VendorContractContractidEditRoute: typeof VendorContractContractidEditRoute
  VendorStoreEditProductidRoute: typeof VendorStoreEditProductidRoute
  VendorContractContractidIndexRoute: typeof VendorContractContractidIndexRoute
}

const VendorRouteChildren: VendorRouteChildren = {
  VendorDisputeRoute: VendorDisputeRouteWithChildren,
  VendorHomeRoute: VendorHomeRoute,
  VendorNotificationsRoute: VendorNotificationsRoute,
  VendorSupportRoute: VendorSupportRoute,
  VendorChatRoomidRoute: VendorChatRoomidRoute,
  VendorContractCartRoute: VendorContractCartRoute,
  VendorContractCreateRoute: VendorContractCreateRoute,
  VendorContractDropoffLocationRoute: VendorContractDropoffLocationRoute,
  VendorOrdersOrderidRoute: VendorOrdersOrderidRoute,
  VendorStoreProductidRoute: VendorStoreProductidRoute,
  VendorStoreCreateRoute: VendorStoreCreateRoute,
  VendorChatIndexRoute: VendorChatIndexRoute,
  VendorContractIndexRoute: VendorContractIndexRoute,
  VendorOrdersIndexRoute: VendorOrdersIndexRoute,
  VendorSettingsIndexRoute: VendorSettingsIndexRoute,
  VendorStoreIndexRoute: VendorStoreIndexRoute,
  VendorContractContractidEditRoute: VendorContractContractidEditRoute,
  VendorStoreEditProductidRoute: VendorStoreEditProductidRoute,
  VendorContractContractidIndexRoute: VendorContractContractidIndexRoute,
}

const VendorRouteWithChildren =
  VendorRoute._addFileChildren(VendorRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  BagRoute: BagRoute,
  BuyerRoute: BuyerRouteWithChildren,
  ContactRoute: ContactRoute,
  DiscoveryRoute: DiscoveryRoute,
  DownloadRoute: DownloadRoute,
  FeaturesRoute: FeaturesRoute,
  FormRoute: FormRoute,
  GetStartedRoute: GetStartedRoute,
  LegalRoute: LegalRoute,
  OnboardingRoute: OnboardingRoute,
  PolicyRoute: PolicyRoute,
  PrivacyRoute: PrivacyRoute,
  QueryRoute: QueryRoute,
  TermsRoute: TermsRoute,
  TestPaymentRoute: TestPaymentRoute,
  VendorRoute: VendorRouteWithChildren,
  VendorRegistrationRoute: VendorRegistrationRoute,
  CheckoutShippingRoute: CheckoutShippingRoute,
  CheckoutSummaryRoute: CheckoutSummaryRoute,
  PaymentContractidRoute: PaymentContractidRoute,
  ProductProductidRoute: ProductProductidRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
